import React from 'react'

function Treatments() {
  return (
    <div class="mt-44 ">
        <h1 class="text-center font-bold text-4xl">Treatments</h1>
      <div className='flex justify-center'>
      <div class="py-11 px-14 ">
      <a class="p-8 max-w-lg border border-indigo-300 rounded-2xl hover:shadow-xl hover:shadow-indigo-50 flex flex-col items-center"
    href="#">
    <img src="https://img.freepik.com/premium-photo/cheerful-young-lady-is-lying-dental-chair-choosing-veeners-colour-with-doctor-help_317809-5350.jpg?w=900" class="shadow rounded-lg overflow-hidden border"/> 
    <div class="mt-8">
        <h4 class="font-bold text-xl">Veneers</h4>
        <p class="mt-2 text-gray-600">Thin shells of porcelain or composite resin bonded to the front of teeth to improve appearance
        </p>
        
    </div>
</a>

      </div>
      <div class="py-11 px-14 ">
      <a class="p-8 max-w-lg border border-indigo-300 rounded-2xl hover:shadow-xl hover:shadow-indigo-50 flex flex-col items-center"
    href="#">
    <img src="https://img.freepik.com/free-photo/caucasian-preteen-girl-with-braces-her-teeth-looking-mirror_169016-38672.jpg?t=st=1717414097~exp=1717417697~hmac=9f59ff004d1b029b55b76198aa148bee8f6d2be881a10fdd1fcd608ce8badedf&w=900" class="shadow rounded-lg overflow-hidden border"/> 
    <div class="mt-8">
        <h4 class="font-bold text-xl">Braces and Orthodontics</h4>
        <p class="mt-2 text-gray-600">Devices used to correct misaligned teeth and jaws, improving bite and aesthetics.
        </p>
       
    </div>
</a>

      </div>
      </div>
      <div className='flex justify-center'>
      <div class="py-11 px-14 ">
      <a class="p-8 max-w-lg border border-indigo-300 rounded-2xl hover:shadow-xl hover:shadow-indigo-50 flex flex-col items-center"
    href="#">
    <img src="https://img.freepik.com/free-photo/female-patient-having-procedure-done-dentist_23-2148985815.jpg?t=st=1717414144~exp=1717417744~hmac=bc63dcf26eeb379feb655bdb6ee07ca311de1ec7dbcf21ff6885c7fa09a6fadd&w=900" class="shadow rounded-lg overflow-hidden border"/> 
    <div class="mt-8">
        <h4 class="font-bold text-xl">Teeth Cleaning</h4>
        <p class="mt-2 text-gray-600">Routine cleaning to remove plaque and tartar buildup to prevent cavities, gingivitis, and periodontal disease.
        </p>
        
    </div>
</a>

      </div>
      <div class="py-11 px-14 ">
      <a class="p-8 max-w-lg border border-indigo-300 rounded-2xl hover:shadow-xl hover:shadow-indigo-50 flex flex-col items-center"
    href="#">
    <img src="https://img.freepik.com/free-photo/unrecognizable-asian-dentist-nurse-examining-male-patient-s-teeth_1098-20337.jpg?t=st=1717414189~exp=1717417789~hmac=6a3e739a50ce25ce50128e46918bb3d15963de71fb1faf6b4eb5afc163c19884&w=900" class="shadow rounded-lg overflow-hidden border"/> 
    <div class="mt-8">
        <h4 class="font-bold text-xl">Root Canal Treatment</h4>
        <p class="mt-2 text-gray-600">Procedure to remove infected or damaged pulp from inside a tooth, followed by cleaning, disinfecting, and filling the space.
        </p>
        
    </div>
</a>

      </div>
      </div>
      <div className='flex justify-center'>
      <div class="py-11 px-14 ">
      <a class="p-8 max-w-lg border border-indigo-300 rounded-2xl hover:shadow-xl hover:shadow-indigo-50 flex flex-col items-center"
    href="#">
    <img src="https://img.freepik.com/free-photo/dentists-treat-patients-teeth_1150-19647.jpg?t=st=1717414222~exp=1717417822~hmac=14daa25ba6bde76673d155658e32e77ce4e72756c58aeeb75afc20e87b7bd810&w=996" class="shadow rounded-lg overflow-hidden border"/> 
    <div class="mt-8">
        <h4 class="font-bold text-xl">Fillings</h4>
        <p class="mt-2 text-gray-600">Used to treat cavities by removing decayed tooth material and filling the area with materials like composite resin, amalgam, or gold.
        </p>
        
    </div>
</a>

      </div>
      <div class="py-11 px-14 ">
      <a class="p-8 max-w-lg border border-indigo-300 rounded-2xl hover:shadow-xl hover:shadow-indigo-50 flex flex-col items-center"
    href="#">
    <img src="https://img.freepik.com/premium-photo/dentist-examining-teeth-young-woman-patient-dental-clinic-dentistry-concept_333900-21810.jpg?w=900" class="shadow rounded-lg overflow-hidden border"/> 
    <div class="mt-8">
        <h4 class="font-bold text-xl">Dental Crowns</h4>
        <p class="mt-2 text-gray-600">Caps placed over a damaged or decayed tooth to restore its shape, size, strength, and appearance.
        </p>
       
    </div>
</a>

      </div>
      </div>
      <h1 class="text-center font-bold text-4xl mb-10">And much more...</h1>
    </div>
  )
}

export default Treatments
